<template lang="pug">
  game-preview-settings
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
      span(slot="value") {{ $i18n.t('common.common_gameName_wordDrum') }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}
      span(slot="value") {{ parameters.themes ? themeNames : '' }}
    game-preview-setting
        span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_isChooseByAlphabetSettingEnabled') }}
        span(slot="value") {{ parameters.isChosenLettersSettingEnabled ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
    game-preview-setting(v-if="parameters.isChosenLettersSettingEnabled" )
        span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_chooseByAlphabet') }}
        span(slot="value") {{ parameters.chosenLetters ? letters : '' }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}
      span(slot="value") {{ parameters.amountOfPairs }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
      span(slot="value") {{ parameters.numOfExamples }}
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}
      span(slot="value") {{ parameters.isHintEnabled ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            themeNames() {
                return this.parameters.themes
                    .map(theme => this.$i18n.t('trainer.trainer_gameFormSetting_' + `${theme.value}`))
                    .join('; ');
            },
            letters() {
                return this.parameters.chosenLetters.map(theme => theme).join('; ');
            },
        },
    };
</script>
